import React from "react";
import UserInvoice from "../Investigation/Invoice/UserInvoice";
import MedicalForm from "../Investigation/Report/MedicalForm/MedicalForm";

const PrintInvoiceFormByUserId = () => {
  // useEffect(() => {
  //   setTimeout(() => {
  //     window.print();
  //   }, 2000);
  // }, []);

  return (
    <div>
      <UserInvoice />

      <div style={{ pageBreakAfter: "always" }}></div>

      <MedicalForm />
    </div>
  );
};

export default PrintInvoiceFormByUserId;
